var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          staticClass: "section top",
          staticStyle: { "flex-direction": "row", "min-width": "1600px" },
          attrs: { disabled: _vm.readonly }
        },
        [
          _c(
            "el-checkbox",
            {
              attrs: { no: "1" },
              on: {
                change: function($event) {
                  return _vm.loadingTerm_Change("warehousing")
                }
              },
              model: {
                value: _vm.job.warehousing,
                callback: function($$v) {
                  _vm.$set(_vm.job, "warehousing", $$v)
                },
                expression: "job.warehousing"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.WarehouseLoadingStorage")))]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { no: "2" },
              on: {
                change: function($event) {
                  return _vm.loadingTerm_Change("landTransportation")
                }
              },
              model: {
                value: _vm.job.landTransportation,
                callback: function($$v) {
                  _vm.$set(_vm.job, "landTransportation", $$v)
                },
                expression: "job.landTransportation"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.DoorLoadingDelivery")))]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { no: "3" },
              model: {
                value: _vm.job.selfDeliver,
                callback: function($$v) {
                  _vm.$set(_vm.job, "selfDeliver", $$v)
                },
                expression: "job.selfDeliver"
              }
            },
            [
              _vm._v(
                _vm._s(_vm.$t("SeaExport.NotResponsibleForTruckingAndLoading"))
              )
            ]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { no: "4" },
              model: {
                value: _vm.job.ams,
                callback: function($$v) {
                  _vm.$set(_vm.job, "ams", $$v)
                },
                expression: "job.ams"
              }
            },
            [_vm._v("AMS/ENS")]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { no: "5" },
              model: {
                value: _vm.job.heating,
                callback: function($$v) {
                  _vm.$set(_vm.job, "heating", $$v)
                },
                expression: "job.heating"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Fumigation")))]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { no: "6" },
              model: {
                value: _vm.job.comercialInspectation,
                callback: function($$v) {
                  _vm.$set(_vm.job, "comercialInspectation", $$v)
                },
                expression: "job.comercialInspectation"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.CommodityInspection")))]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { no: "7" },
              on: {
                change: function(val) {
                  _vm.job.customsBroker = val ? _vm.job.customsBroker : 0
                  _vm.job.customsDeclarationType = val
                    ? _vm.job.customsDeclarationType
                    : -1
                }
              },
              model: {
                value: _vm.job.customs,
                callback: function($$v) {
                  _vm.$set(_vm.job, "customs", $$v)
                },
                expression: "job.customs"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.CustomsDeclaration")))]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { no: "8" },
              model: {
                value: _vm.job.signMBL,
                callback: function($$v) {
                  _vm.$set(_vm.job, "signMBL", $$v)
                },
                expression: "job.signMBL"
              }
            },
            [_vm._v("MB/L")]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { no: "9", disabled: _vm.job.mblOnly },
              model: {
                value: _vm.job.signHBL,
                callback: function($$v) {
                  _vm.$set(_vm.job, "signHBL", $$v)
                },
                expression: "job.signHBL"
              }
            },
            [_vm._v("HB/L")]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { no: "10" },
              on: { change: _vm.mblOnlyChange },
              model: {
                value: _vm.job.mblOnly,
                callback: function($$v) {
                  _vm.$set(_vm.job, "mblOnly", $$v)
                },
                expression: "job.mblOnly"
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.DirectBusiness")))]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { no: "11" },
              model: {
                value: _vm.job.salePrice,
                callback: function($$v) {
                  _vm.$set(_vm.job, "salePrice", $$v)
                },
                expression: "job.salePrice"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.SpecialPrice")))]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { no: "12" },
              model: {
                value: _vm.job.availableCabinSpace,
                callback: function($$v) {
                  _vm.$set(_vm.job, "availableCabinSpace", $$v)
                },
                expression: "job.availableCabinSpace"
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_AvailableCabinSpace")))]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { no: "destinationPortService" },
              on: { change: _vm.destinationPortServiceChange },
              model: {
                value: _vm.job.destinationPortService,
                callback: function($$v) {
                  _vm.$set(_vm.job, "destinationPortService", $$v)
                },
                expression: "job.destinationPortService"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.PortOfDestinationServices")))]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "section top", staticStyle: { "min-width": "1600px" } },
        [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BasicInfo")))
          ]),
          _c(
            "el-form",
            {
              attrs: {
                disabled: _vm.readonly,
                inline: true,
                "label-width": "135px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_BusinessNo"),
                    "label-width": "125px"
                  }
                },
                [
                  _c("el-input", {
                    staticClass: "job-no-color input2",
                    attrs: { no: "12", disabled: true },
                    model: {
                      value: _vm.job.jobNo,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "jobNo", $$v)
                      },
                      expression: "job.jobNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_WarehouseNo") } },
                [
                  _c("el-input", {
                    staticClass: "input2",
                    attrs: { no: "13" },
                    model: {
                      value: _vm.job.warehouseNo,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "warehouseNo", $$v)
                      },
                      expression: "job.warehouseNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.quotationNum") } },
                [
                  _c("el-input", {
                    staticClass: "input2",
                    attrs: {
                      no: "14",
                      value: _vm.job.quotationNo,
                      disabled: true
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("Payment.businessReferenceNumber"),
                    "label-width": "100px"
                  }
                },
                [
                  _c("cargo-input", {
                    staticClass: "input2",
                    attrs: { no: "15", trim: true },
                    model: {
                      value: _vm.job.customerRefNo,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "customerRefNo", $$v)
                      },
                      expression: "job.customerRefNo"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("div", [
            _c(
              "div",
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      inline: true,
                      "label-width": "135px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { "label-width": "125px" } },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("Payment.consignationCompany"))
                            )
                          ]
                        ),
                        _vm.accountObjectControlMode === 2
                          ? _c("cargo-sales-company-select", {
                              attrs: {
                                no: "16",
                                disabled: !(
                                  !_vm.job.mbl && _vm.electricBusinessBtnEnable
                                ),
                                "method-params": {
                                  customer: true,
                                  active: true
                                },
                                "check-credit": true,
                                job: _vm.job,
                                "default-value": _vm.job.customerId || "",
                                placeholder: _vm.$t("SeaExport.RequiredItem")
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.txtCustomerId_changeHandler(p)
                                  _vm.clearPoNo()
                                }
                              }
                            })
                          : _c("cargo-company-select", {
                              attrs: {
                                no: "16",
                                disabled: !(
                                  !_vm.job.mbl && _vm.electricBusinessBtnEnable
                                ),
                                "method-params": {
                                  customer: true,
                                  active: true
                                },
                                "check-credit": true,
                                job: _vm.job,
                                "default-value": _vm.job.customerId || "",
                                "static-options": _vm.customerCmpList,
                                placeholder: _vm.$t("SeaExport.RequiredItem"),
                                "custom-style": "width:260px"
                              },
                              on: {
                                change: function(p) {
                                  _vm.txtCustomerId_changeHandler(p)
                                  _vm.clearPoNo()
                                }
                              }
                            })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Payment.contactPerson") } },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "input2",
                            attrs: {
                              no: "17",
                              disabled: !_vm.electricBusinessBtnEnable,
                              filterable: "",
                              "allow-create": true,
                              placeholder: ""
                            },
                            on: { change: _vm.tfLinkman_closeHandler },
                            model: {
                              value: _vm.job.customerContact,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "customerContact", $$v)
                              },
                              expression: "job.customerContact"
                            }
                          },
                          _vm._l(_vm.contactList, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: item.contactPerson,
                                value: item.contactPerson
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isShowContactPersonDetail,
                            expression: "!isShowContactPersonDetail"
                          }
                        ],
                        attrs: { label: _vm.$t("SeaExport.Tel") }
                      },
                      [
                        _c("el-input", {
                          staticClass: "input2",
                          attrs: {
                            no: "18",
                            disabled: !_vm.electricBusinessBtnEnable,
                            maxlength: "32"
                          },
                          model: {
                            value: _vm.job.contactTelephone,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "contactTelephone", $$v)
                            },
                            expression: "job.contactTelephone"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isShowContactPersonDetail,
                            expression: "!isShowContactPersonDetail"
                          }
                        ],
                        attrs: {
                          label: _vm.$t("SeaExport.Fax"),
                          "label-width": "100px"
                        }
                      },
                      [
                        _c("el-input", {
                          staticClass: "input2",
                          attrs: {
                            no: "19",
                            disabled: !_vm.electricBusinessBtnEnable,
                            maxlength: "32"
                          },
                          model: {
                            value: _vm.job.contactFax,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "contactFax", $$v)
                            },
                            expression: "job.contactFax"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      inline: true,
                      "label-width": "135px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "blue",
                        attrs: { "label-width": "125px" }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("Payment.sales")))]
                        ),
                        _c("cargo-user-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "20",
                            disabled: !(
                              !_vm.job.trustFromJob &&
                              _vm.electricBusinessBtnEnable &&
                              (!_vm.validateCustomerSales ||
                                (_vm.isSpecifiedSalesBusiness &&
                                  _vm.validateCustomerSales))
                            ),
                            "method-params": {
                              officeId:
                                !_vm.isSpecifiedSalesBusiness &&
                                _vm.salesOfficeCheck
                                  ? _vm.$store.getters.currentOfficeId
                                  : "",
                              category: "role",
                              shape: "sales"
                            },
                            "default-value": _vm.job.sales || "",
                            "static-options": _vm.salesList,
                            placeholder: _vm.$t("SeaExport.RequiredItem"),
                            "merge-load": true
                          },
                          on: { change: _vm.txtSales_changeHandler }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("queryJob.salesDepartment")))]
                        ),
                        _c("cargo-department-new-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "21",
                            disabled: !(
                              _vm.job.sales > 0 && _vm.job.salesDepartment > 0
                            ),
                            "sales-id": _vm.job.sales,
                            "office-id": _vm.job.salesOffice,
                            "department-id": _vm.job.salesDepartment,
                            "show-office-prefix": false,
                            placeholder: " "
                          },
                          on: {
                            change: function(p) {
                              _vm.job.salesDepartment = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { staticClass: "blue" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.SalesCompany")))]
                        ),
                        _c("el-input", {
                          staticClass: "input2",
                          attrs: {
                            no: "22",
                            disabled: true,
                            placeholder: _vm.$t("SeaExport.RequiredItem")
                          },
                          model: {
                            value: _vm.txtSalesOffice,
                            callback: function($$v) {
                              _vm.txtSalesOffice = $$v
                            },
                            expression: "txtSalesOffice"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("Payment.customerService"),
                          "label-width": "100px"
                        }
                      },
                      [
                        _c("cargo-user-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "23",
                            disabled: Boolean(_vm.job.trustFromJob),
                            "method-params": {
                              category: "role",
                              shape: "csr",
                              officeId: _vm.job.opOffice
                            },
                            "default-value": _vm.job.csr || "",
                            "static-options":
                              _vm.userPortRoleData.csr || _vm.csrList,
                            placeholder: " ",
                            "merge-load": true
                          },
                          on: { change: _vm.csrChangeHandler }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      inline: true,
                      "label-width": "135px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("FileHistory.operation"),
                          "label-width": "125px"
                        }
                      },
                      [
                        _c("cargo-user-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "24",
                            disabled: Boolean(_vm.job.trustFromJob),
                            "method-params": {
                              category: "role",
                              shape: "op",
                              officeId: _vm.$store.getters.currentOfficeId
                            },
                            "default-value": _vm.job.op || "",
                            placeholder: " ",
                            "static-options": _vm.userPortRoleData.op,
                            "merge-load": true
                          },
                          on: { change: _vm.txtOPChangeHandler }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("queryJob.operationDepartment") }
                      },
                      [
                        _c("cargo-department-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "25",
                            disabled: Boolean(_vm.job.trustFromJob),
                            "office-id": _vm.job.opOffice,
                            enables: true,
                            "department-id": _vm.job.opDepartment,
                            placeholder: " "
                          },
                          on: {
                            change: function(p) {
                              _vm.job.opDepartment = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.OperationCompany") }
                      },
                      [
                        _c("cargo-advance-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "26",
                            disabled: _vm.isEntrustOrder(),
                            "select-type": _vm.TYPE_NAMES.basic_data_Office,
                            filterable: "",
                            "default-value": _vm.job.opOffice || "",
                            placeholder: " "
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.job.opOffice = p.value
                              _vm.opOfficeChargeHandler()
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.FieldOperation"),
                          "label-width": "100px"
                        }
                      },
                      [
                        _c("cargo-user-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "27",
                            "method-params": {
                              officeId: _vm.$store.getters.currentOfficeId,
                              category: "role",
                              shape: "siteOp"
                            },
                            "default-value": _vm.job.siteOP || "",
                            placeholder: " ",
                            "static-options": _vm.userPortRoleData.siteOp,
                            "merge-load": true
                          },
                          on: {
                            change: function(p) {
                              _vm.JobUtils.siteOpChangeHandler(_vm.job, p)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      inline: true,
                      "label-width": "135px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.SalesOfGoods"),
                          "label-width": "125px"
                        }
                      },
                      [
                        _c("cargo-user-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "28",
                            "method-params": {
                              category: "role",
                              shape: "salesOfGoods"
                            },
                            "default-value": _vm.job.cargoSalesId || "",
                            "static-options": _vm.cargoSalesList,
                            placeholder: " ",
                            "merge-load": true
                          },
                          on: { change: _vm.cargoSalesChargeHandler }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("queryJob.Documents") } },
                      [
                        _c("cargo-user-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "29",
                            disabled: Boolean(_vm.job.trustFromJob),
                            "method-params": {
                              category: "role",
                              shape: "doc",
                              officeId: _vm.$store.getters.currentOfficeId
                            },
                            "default-value": _vm.job.dc || "",
                            "static-options":
                              _vm.userPortRoleData.doc || _vm.dcList,
                            placeholder: " ",
                            "merge-load": true
                          },
                          on: { change: _vm.dcChangeHandler }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Payment.planner") } },
                      [
                        _c("cargo-user-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "30",
                            "method-params": {
                              category: "role",
                              shape: "sealine",
                              officeId: _vm.$store.getters.currentOfficeId
                            },
                            "default-value": _vm.job.planner || "",
                            placeholder: " ",
                            "static-options": _vm.userPortRoleData.seaLine,
                            "merge-load": true
                          },
                          on: { change: _vm.txtPlannerChangeHandler }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.OverseaCustomerService"),
                          "label-width": "100px"
                        }
                      },
                      [
                        _c("cargo-user-select", {
                          ref: "overseaOp",
                          staticClass: "input2",
                          attrs: {
                            no: "overseaOp",
                            placeholder: " ",
                            "default-value": _vm.job.overseaOp || "",
                            "method-params": {
                              category: "role",
                              shape: "overseaOp"
                            },
                            "static-options": _vm.isHc
                              ? null
                              : _vm.userPortRoleData.overseaOp ||
                                _vm.overseaAgentUsersList,
                            "merge-load": true
                          },
                          on: {
                            change: function(p) {
                              _vm.job.overseaOp = p.value
                              _vm.OverseaCustomerUtils.overseaOpChangeHandler(
                                _vm.view,
                                p
                              )
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      inline: true,
                      "label-width": "135px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("Message.Customer_Service"),
                          "label-width": "125px"
                        }
                      },
                      [
                        _c("cargo-department-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "csrDepartment",
                            "office-id": Number(_vm.job.csrOffice),
                            enables: true,
                            "department-id": Number(_vm.job.csrDepartment)
                          },
                          on: {
                            change: function(p) {
                              _vm.job.csrDepartment = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.CustomerOffice") } },
                      [
                        _c("cargo-advance-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "csrOffice",
                            disabled: true,
                            "select-type": _vm.TYPE_NAMES.basic_data_Office,
                            filterable: "",
                            "default-value": _vm.job.csrOffice || ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.job.csrOffice = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("Message.Documentation_Department")
                        }
                      },
                      [
                        _c("cargo-department-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "dcDepartment",
                            "office-id": Number(_vm.job.dcOffice),
                            enables: true,
                            "department-id": Number(_vm.job.dcDepartment)
                          },
                          on: {
                            change: function(p) {
                              _vm.job.dcDepartment = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.DocumentOffice"),
                          "label-width": "100px"
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "dcOffice",
                            disabled: true,
                            "select-type": _vm.TYPE_NAMES.basic_data_Office,
                            filterable: "",
                            "default-value": _vm.job.dcOffice || ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.job.dcOffice = p.value
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      inline: true,
                      "label-width": "135px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        class: _vm.poNoRed ? "poNoClass" : "",
                        attrs: {
                          label: _vm.$t("Payment.itemNo"),
                          "label-width": "125px"
                        }
                      },
                      [
                        !_vm.openProjectConfig
                          ? _c("el-input", {
                              staticClass: "input2",
                              attrs: { no: "31" },
                              model: {
                                value: _vm.job.poNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "poNo", $$v)
                                },
                                expression: "job.poNo"
                              }
                            })
                          : _vm._e(),
                        _vm.openProjectConfig
                          ? _c("cargo-project-select", {
                              staticClass: "input2",
                              attrs: {
                                no: "32",
                                "default-value": _vm.job.poNo,
                                "customer-id": _vm.job.customerId,
                                "is-linked": _vm.isProjectLinkedCustomer
                              },
                              on: { change: _vm.changeProject }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.AirlineDepartment") }
                      },
                      [
                        _c("cargo-department-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "plannerDepartment",
                            "office-id": Number(_vm.job.plannerOffice),
                            enables: true,
                            "department-id": Number(_vm.job.plannerDepartment)
                          },
                          on: {
                            change: function(p) {
                              _vm.job.plannerDepartment = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.AirlineOffice") } },
                      [
                        _c("cargo-advance-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "plannerOffice",
                            disabled: true,
                            "select-type": _vm.TYPE_NAMES.basic_data_Office,
                            filterable: "",
                            "default-value": _vm.job.plannerOffice || ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.job.plannerOffice = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm.openProjectConfig
                      ? _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("SeaExport.ProjectName") } },
                          [
                            _c("el-input", {
                              staticClass: "input2",
                              attrs: { no: "33", disabled: true },
                              model: {
                                value: _vm.job.projectName,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "projectName", $$v)
                                },
                                expression: "job.projectName"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.openProjectConfig
                      ? _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("SeaExport.ProjectBatch") }
                          },
                          [
                            _c("el-input", {
                              staticClass: "input2",
                              attrs: { no: "34" },
                              model: {
                                value: _vm.job.projectBatch,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "projectBatch", $$v)
                                },
                                expression: "job.projectBatch"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm.isAddUserDefinedRoles
                  ? _c(
                      "el-form",
                      {
                        attrs: {
                          disabled: _vm.readonly,
                          inline: true,
                          "label-width": "135px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_userDefinedRole1"),
                              "label-width": "125px"
                            }
                          },
                          [
                            _c("cargo-user-select", {
                              staticClass: "input2",
                              attrs: {
                                no: "35",
                                "method-params": {
                                  officeId: _vm.$store.getters.currentOfficeId,
                                  category: "role",
                                  shape: "userDefinedRole1"
                                },
                                "default-value":
                                  _vm.job.userDefinedRoleId1 || "",
                                placeholder: " ",
                                "static-options":
                                  _vm.userPortRoleData.userDefinedRole1,
                                "merge-load": true
                              },
                              on: { change: _vm.userDefinedRoleId1Handler }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_userDefinedRole2")
                            }
                          },
                          [
                            _c("cargo-user-select", {
                              staticClass: "input2",
                              attrs: {
                                no: "36",
                                "method-params": {
                                  officeId: _vm.$store.getters.currentOfficeId,
                                  category: "role",
                                  shape: "userDefinedRole2"
                                },
                                "default-value":
                                  _vm.job.userDefinedRoleId2 || "",
                                placeholder: " ",
                                "static-options":
                                  _vm.userPortRoleData.userDefinedRole2
                              },
                              on: { change: _vm.userDefinedRoleId2Handler }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.job.preverifyState === 3,
                    expression: "job.preverifyState===3"
                  }
                ],
                staticStyle: { display: "flex" }
              },
              [
                _c(
                  "span",
                  { staticStyle: { width: "100px", display: "inline-block" } },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DenialReason")))]
                ),
                _c("el-input", {
                  staticStyle: { width: "260px" },
                  attrs: {
                    no: "37",
                    type: "textarea",
                    rows: 3,
                    disabled: true
                  },
                  model: {
                    value: _vm.job.bookingRefuseNote,
                    callback: function($$v) {
                      _vm.$set(_vm.job, "bookingRefuseNote", $$v)
                    },
                    expression: "job.bookingRefuseNote"
                  }
                })
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "section", staticStyle: { "min-width": "1600px" } },
        [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ShippingInformation")))
          ]),
          _c(
            "div",
            {
              staticClass: "form-item-w260",
              staticStyle: { display: "flex", "flex-direction": "row" }
            },
            [
              _c(
                "el-form",
                {
                  staticStyle: { "margin-right": "10px" },
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": "125px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.$t("SeaExport.Shipper") }
                    },
                    [
                      _c("cargo-company-select", {
                        class: _vm.isZh ? "shipper-input" : "shipper-input-en",
                        attrs: {
                          no: "38",
                          disabled: _vm.readonly,
                          "method-params": { shipper: true, active: true },
                          "default-value": _vm.job.shipperId || "",
                          placeholder: " ",
                          "static-options": _vm.hasChooseOwnTransceiverPermission
                            ? _vm.privateShipperList
                            : null
                        },
                        on: { change: _vm.shipperChange }
                      }),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { no: "39", type: "primary" },
                          on: {
                            click: function($event) {
                              _vm.billAddressDialog.visible = true
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                      )
                    ],
                    1
                  ),
                  _vm._l(7, function(i) {
                    return _c(
                      "el-form-item",
                      { key: i, staticClass: "auto-width" },
                      [
                        _c("cargo-input", {
                          ref: "shipperLine" + i,
                          refInFor: true,
                          attrs: {
                            no: "40",
                            "auto-uppercase":
                              _vm.notUppercaseShipperConsigneNotify
                          },
                          on: {
                            change: function() {
                              return _vm.wrapAddr(
                                _vm.job,
                                "shipperLine" + i,
                                i + 1 > 7 ? null : "shipperLine" + (i + 1),
                                200
                              )
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.Shipper"),
                                _vm.mergeShipperLine(),
                                _vm.splitShipperLine,
                                true
                              )
                            }
                          },
                          model: {
                            value: _vm.job["shipperLine" + i],
                            callback: function($$v) {
                              _vm.$set(_vm.job, "shipperLine" + i, $$v)
                            },
                            expression: "job['shipperLine'+i]"
                          }
                        })
                      ],
                      1
                    )
                  }),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.DateOfDeparture")))]
                      ),
                      _c("el-date-picker", {
                        attrs: {
                          no: "41",
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          clearable: "",
                          placeholder: _vm.$t("SeaExport.RequiredItem")
                        },
                        on: { input: _vm.etdChange },
                        model: {
                          value: _vm.job.etd,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "etd", $$v)
                          },
                          expression: "job.etd"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_ArrivalTime") } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          no: "42",
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          clearable: ""
                        },
                        model: {
                          value: _vm.job.eta,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "eta", $$v)
                          },
                          expression: "job.eta"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CYCutOffDate2") } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          no: "43",
                          type: "datetime",
                          format: "yyyy-MM-dd HH:mm",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          clearable: ""
                        },
                        model: {
                          value: _vm.job.customCutoff,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "customCutoff", $$v)
                          },
                          expression: "job.customCutoff"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.job.ams,
                          expression: "job.ams"
                        }
                      ],
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_AmsEnsCyCutOffDate")
                      }
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          no: "44",
                          type: "datetime",
                          format: "yyyy-MM-dd HH:mm",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          clearable: ""
                        },
                        model: {
                          value: _vm.job.amsCutoff,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "amsCutoff", $$v)
                          },
                          expression: "job.amsCutoff"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "CargoMsg.Cargo_StartDateOfContainerReturn"
                        )
                      }
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          no: "45",
                          type: "datetime",
                          format: "yyyy-MM-dd HH:mm",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          clearable: ""
                        },
                        model: {
                          value: _vm.job.returnPeriodBegin,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "returnPeriodBegin", $$v)
                          },
                          expression: "job.returnPeriodBegin"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "CargoMsg.Cargo_CloseDateOfContainerReturn"
                        )
                      }
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          no: "46",
                          type: "datetime",
                          format: "yyyy-MM-dd HH:mm",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          clearable: ""
                        },
                        model: {
                          value: _vm.job.returnPeriodEnd,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "returnPeriodEnd", $$v)
                          },
                          expression: "job.returnPeriodEnd"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.PlaceOfReceipt") } },
                    [
                      _c("el-input", {
                        attrs: { no: "47" },
                        model: {
                          value: _vm.job.dispatchingPlace,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "dispatchingPlace", $$v)
                          },
                          expression: "job.dispatchingPlace"
                        }
                      })
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "span",
                      {
                        staticClass: "blue",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.PortOfLoading")))]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between"
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          staticClass: "port-item",
                          style: {
                            width: _vm.isZh ? "" : "190px",
                            minWidth: _vm.isZh ? "" : "190px"
                          },
                          attrs: {
                            no: "48",
                            filterable: "",
                            "select-type": _vm.TYPE_NAMES.basic_data_Seaport,
                            "default-value": _vm.job.loadingPortCode,
                            placeholder: _vm.$t("SeaExport.RequiredItem")
                          },
                          on: { parentCallBack: _vm.loadingPortCode_Change }
                        }),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { margin: "0 0 0 10px" },
                            attrs: { no: "49" },
                            model: {
                              value: _vm.job.transfering,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "transfering", $$v)
                              },
                              expression: "job.transfering"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Transit")))]
                        )
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.job.transfering,
                          expression: "job.transfering"
                        }
                      ],
                      attrs: { label: _vm.$t("SeaExport.TransitPort") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "50",
                          "select-type": _vm.TYPE_NAMES.basic_data_Seaport,
                          filterable: "",
                          "default-value": _vm.job.transferPortCode,
                          placeholder: _vm.$t("SeaExport.RequiredItem")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.transferPortCode = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.PortOfDischarge")))]
                      ),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "51",
                          disabled: !(
                            !_vm.job.mbl && _vm.electricBusinessBtnEnable
                          ),
                          "select-type": _vm.TYPE_NAMES.basic_data_Seaport,
                          filterable: "",
                          "default-value": _vm.job.dischargingPortCode,
                          placeholder: _vm.$t("SeaExport.RequiredItem")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.dischargingPortCodeChange(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("queryJob.placeOfDelivery")))]
                      ),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "52",
                          "select-type": _vm.TYPE_NAMES.basic_data_Seaport,
                          filterable: "",
                          "default-value": _vm.job.destinationPortCode,
                          placeholder: _vm.$t("SeaExport.RequiredItem")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.destinationPortCode_Change(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_PlaceOfDeliveryRegion"))
                        )
                      ]),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "117",
                          "select-type": _vm.TYPE_NAMES.basic_data_Region,
                          filterable: "",
                          "default-value": _vm.job.placeOfDeliveryRegion
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.placeOfDeliveryRegion = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.FinalDestination") } },
                    [
                      _c("el-input", {
                        attrs: { no: "53" },
                        on: { change: _vm.changeDestinationPlace },
                        model: {
                          value: _vm.job.destinationPlace,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "destinationPlace", $$v)
                          },
                          expression: "job.destinationPlace"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.SolicitationType") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "54",
                          filterable: "",
                          "select-type": _vm.TYPE_NAMES.local_cache_CargoSource,
                          "default-value": _vm.job.cargoSource,
                          clearable: false
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.cargoSource = p.value
                            _vm.cargoSource_Change()
                            _vm.txtCargoSourceChangeHandler()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm.job.cargoSource === "NC"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            id: "agentRefNo",
                            label: _vm.$t("SeaExport.NCReferenceNo")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "agentRefNo" },
                            model: {
                              value: _vm.job.agentRefNo,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "agentRefNo", $$v)
                              },
                              expression: "job.agentRefNo"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CustomJobType") } },
                    [
                      _c("cargo-advance-select", {
                        ref: "customJobType",
                        attrs: {
                          no: "55",
                          filterable: "",
                          "select-type": _vm.TYPE_NAMES.basic_data_CutomJobType,
                          "method-params": { type: _vm.job.lob, active: true },
                          "default-value": _vm.job.customJobType,
                          placeholder: _vm.$t("Message.PleaseSelect")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.customJobType = p.value
                            _vm.onCustomJobTypeChange()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Payment.destinationAgent") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "56",
                          "select-type": _vm.TYPE_NAMES.basic_data_Company,
                          filterable: "",
                          "method-params": {
                            overseaAgent: true,
                            companyLob: "seaExport",
                            active: true
                          },
                          "default-value": _vm.job.destinationAgent || "",
                          placeholder: " "
                        },
                        on: {
                          parentCallBack: _vm.txtDestinationAgentChangeHandler
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.job.cargoSource === "NC",
                          expression: "job.cargoSource==='NC'"
                        }
                      ]
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("queryJob.nominatedAgent")))]
                      ),
                      _c("cargo-company-select", {
                        staticStyle: { width: "300px" },
                        attrs: {
                          no: "57",
                          "method-params": {
                            designationAgent: true,
                            active: true
                          },
                          "check-credit": true,
                          job: _vm.job,
                          "default-value": _vm.job.designationAgent || "",
                          "tag-name": "englishName",
                          placeholder: " "
                        },
                        on: { change: _vm.txtDesignationAgentChangeHandler }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.bookingAgentVisible,
                          expression: "bookingAgentVisible"
                        }
                      ],
                      attrs: { label: _vm.$t("queryJob.bookingAgent") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "58",
                          filterable: "",
                          "select-type": _vm.TYPE_NAMES.basic_data_Company,
                          "method-params": {
                            bookingAgent: true,
                            companyLob: "seaExport",
                            active: true
                          },
                          "default-value": _vm.job.bookingAgent || "",
                          placeholder: " "
                        },
                        on: { parentCallBack: _vm.bookingAgentChangeHandler }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Message.TerminalCompany") } },
                    [
                      _c("cargo-company-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "terminalCompany",
                          "method-params": {
                            terminalCompany: true,
                            companyLob: "seaExport",
                            active: true
                          },
                          "default-value": _vm.job.terminalCompany || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.JobUtils.terminalCompanyChangeHandler(
                              _vm.job,
                              p
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.ShippingCompany") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "59",
                          filterable: "",
                          "select-type": _vm.TYPE_NAMES.basic_data_Company,
                          "method-params": {
                            seaCmp: true,
                            companyLob: "seaExport",
                            active: true
                          },
                          "default-value": _vm.job.carrierId || "",
                          placeholder: " "
                        },
                        on: { parentCallBack: _vm.carrierChangeHandler }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("queryJob.shippingCompanyContractNo")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "60" },
                        model: {
                          value: _vm.job.scNo,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "scNo", $$v)
                          },
                          expression: "job.scNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CargoType") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "61",
                          filterable: "",
                          "select-type": _vm.TYPE_NAMES.basic_data_CargoType,
                          "method-params": { sea: true },
                          "default-value": _vm.job.cargoType,
                          clearable: false
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.cargoType = p.value
                            _vm.onCargoTypeChange()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("queryJob.masterBLFreightTerm") }
                    },
                    [
                      _c("cargo-require-advance-select", {
                        attrs: {
                          no: "62",
                          filterable: "",
                          "select-type": _vm.TYPE_NAMES.basic_data_PaymentTerm,
                          "default-value": _vm.job.paymentTermMBL,
                          clearable: false
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.paymentTermMBL = p.value
                            _vm.portChange()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.PlaceOfMblPayment") } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "63",
                          disabled:
                            _vm.job.paymentTermMBL === "CC" ||
                            _vm.job.paymentTermMBL === "PPAC"
                        },
                        model: {
                          value: _vm.mblDoc.paymentPlaceBL,
                          callback: function($$v) {
                            _vm.$set(_vm.mblDoc, "paymentPlaceBL", $$v)
                          },
                          expression: "mblDoc.paymentPlaceBL"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.job.mblOnly,
                          expression: "!job.mblOnly"
                        }
                      ],
                      attrs: { label: _vm.$t("queryJob.HBLFreightClause") }
                    },
                    [
                      _c("cargo-require-advance-select", {
                        attrs: {
                          no: "64",
                          "select-type": _vm.TYPE_NAMES.basic_data_PaymentTerm,
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.job.paymentTermHBL
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.paymentTermHBL = p.value
                            _vm.portChange()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.job.mblOnly,
                          expression: "!job.mblOnly"
                        }
                      ],
                      attrs: { label: _vm.$t("SeaExport.PlaceOfHblPayment") }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "65" },
                        model: {
                          value: _vm.hdoc.paymentPlaceBL,
                          callback: function($$v) {
                            _vm.$set(_vm.hdoc, "paymentPlaceBL", $$v)
                          },
                          expression: "hdoc.paymentPlaceBL"
                        }
                      })
                    ],
                    1
                  )
                ],
                2
              ),
              _c(
                "el-form",
                {
                  staticStyle: { "margin-right": "10px" },
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": "135px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.$t("SeaExport.Consignee") }
                    },
                    [
                      _c("cargo-company-select", {
                        class: _vm.isZh ? "shipper-input" : "shipper-input-en",
                        attrs: {
                          no: "66",
                          disabled: _vm.readonly,
                          "method-params": { consignee: true, active: true },
                          "default-value": _vm.job.consigneeId || "",
                          placeholder: " ",
                          "static-options": _vm.hasChooseOwnTransceiverPermission
                            ? _vm.privateConsigneeList
                            : null
                        },
                        on: { change: _vm.consigneeChange }
                      }),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { no: "67", type: "primary" },
                          on: {
                            click: function($event) {
                              _vm.billAddressDialog.visible = true
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                      )
                    ],
                    1
                  ),
                  _vm._l(7, function(i) {
                    return _c(
                      "el-form-item",
                      { key: i, staticClass: "auto-width" },
                      [
                        _c("cargo-input", {
                          ref: "consigneeLine" + i,
                          refInFor: true,
                          attrs: {
                            no: "68",
                            "auto-uppercase":
                              _vm.notUppercaseShipperConsigneNotify
                          },
                          on: {
                            change: function() {
                              return _vm.wrapAddr(
                                _vm.job,
                                "consigneeLine" + i,
                                i + 1 > 7 ? null : "consigneeLine" + (i + 1),
                                200
                              )
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.Consignee"),
                                _vm.mergeConsigneeLine(),
                                _vm.splitConsigneeLine,
                                true
                              )
                            }
                          },
                          model: {
                            value: _vm.job["consigneeLine" + i],
                            callback: function($$v) {
                              _vm.$set(_vm.job, "consigneeLine" + i, $$v)
                            },
                            expression: "job['consigneeLine'+i]"
                          }
                        })
                      ],
                      1
                    )
                  }),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Payment.vessel") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "69",
                          "select-type": _vm.TYPE_NAMES.static_data_Vessel,
                          cache: false,
                          filterable: "",
                          "allow-create": true,
                          "default-value": _vm.job.vessel,
                          "static-options": _vm.vesselList,
                          placeholder: " "
                        },
                        on: { parentCallBack: _vm.onVesselSelectionChange }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Payment.voyage") } },
                    [
                      _c("cargo-advance-select", {
                        ref: "voyageFlight",
                        attrs: {
                          no: "70",
                          cache: false,
                          filterable: "",
                          clearable: "",
                          "allow-create": true,
                          "default-value": _vm.job.voyageFlight,
                          "tag-name": "voyageNo",
                          "tag-value": "voyageNo",
                          "static-options": _vm.voyages,
                          placeholder: " "
                        },
                        on: {
                          focus: _vm.txtVoyageFocusInHandler,
                          parentCallBack: function(p) {
                            _vm.job.voyageFlight = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "IMO" } },
                    [
                      _c("el-input", {
                        attrs: { no: "71" },
                        model: {
                          value: _vm.job.vesselIMO,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "vesselIMO", $$v)
                          },
                          expression: "job.vesselIMO"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_FeederOrNot") } },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-checkbox", {
                            attrs: { no: "72" },
                            model: {
                              value: _vm.showBargeCustomCutoff,
                              callback: function($$v) {
                                _vm.showBargeCustomCutoff = $$v
                              },
                              expression: "showBargeCustomCutoff"
                            }
                          }),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showBargeCustomCutoff,
                                  expression: "showBargeCustomCutoff"
                                }
                              ]
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "驳船" +
                                    _vm._s(
                                      _vm.$t("SeaExport.BargeCYCutOffDate2")
                                    )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showBargeCustomCutoff,
                          expression: "showBargeCustomCutoff"
                        }
                      ]
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          no: "73",
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          clearable: ""
                        },
                        model: {
                          value: _vm.job.bargeCustomCutoff,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "bargeCustomCutoff", $$v)
                          },
                          expression: "job.bargeCustomCutoff"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showBargeCustomCutoff,
                          expression: "showBargeCustomCutoff"
                        }
                      ],
                      attrs: { label: _vm.$t("SeaExport.BargePOL") }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "74" },
                        model: {
                          value: _vm.job.bargePOL,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "bargePOL", $$v)
                          },
                          expression: "job.bargePOL"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_AirlineCode") } },
                    [
                      _c("el-input", {
                        attrs: { no: "75" },
                        model: {
                          value: _vm.job.vesselLineCode,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "vesselLineCode", $$v)
                          },
                          expression: "job.vesselLineCode"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { no: "76" },
                          on: {
                            change: function($event) {
                              return _vm.containerLoadType_Change()
                            }
                          },
                          model: {
                            value: _vm.job.containerLoadType,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "containerLoadType", $$v)
                            },
                            expression: "job.containerLoadType"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: "FCL" } }, [
                            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_FCL")))
                          ]),
                          _c("el-radio", { attrs: { label: "LCL" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_DirectConsol"))
                            )
                          ]),
                          _c("el-radio", { attrs: { label: "BB" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_CoLoadConsol"))
                            )
                          ]),
                          _c("el-radio", { attrs: { label: "BC" } }, [
                            _vm._v("Buyer Console")
                          ]),
                          _c("el-radio", { attrs: { label: "BULK" } }, [
                            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BulkCargo")))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.job.containerLoadType === "FCL" ||
                            _vm.job.containerLoadType === "BB",
                          expression:
                            "job.containerLoadType==='FCL'||job.containerLoadType==='BB'"
                        }
                      ],
                      staticClass: "auto-width"
                    },
                    [
                      _c("booking-sea-eq-data-grid", {
                        ref: "bookingSeaEqDataGrid",
                        staticStyle: { width: "260px" },
                        attrs: {
                          value: _vm.seaEqList,
                          "container-load-type": _vm.job.containerLoadType,
                          "is-edit": _vm.isEdit,
                          job: _vm.job,
                          "hide-soc": true
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.job.containerLoadType === "FCL" ||
                            _vm.job.containerLoadType === "BB",
                          expression:
                            "job.containerLoadType==='FCL'||job.containerLoadType==='BB'"
                        }
                      ],
                      staticClass: "auto-width",
                      style: {
                        width: "50%",
                        marginTop: _vm.isEdit ? "-40px" : ""
                      },
                      attrs: { "label-width": "0" }
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          style: { marginRight: "10px" },
                          on: { change: _vm.socChange },
                          model: {
                            value: _vm.job.soc,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "soc", $$v)
                            },
                            expression: "job.soc"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Soc")))]
                      ),
                      _c(
                        "el-radio-group",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.job.soc,
                              expression: "job.soc"
                            }
                          ],
                          style: { display: "flex", marginTop: "2px" },
                          attrs: { no: "118" },
                          model: {
                            value: _vm.job.socType,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "socType", $$v)
                            },
                            expression: "job.socType"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v(_vm._s(_vm.$t("CargoMsg.CargoOwnerSOC")))
                          ]),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v(_vm._s(_vm.$t("CargoMsg.ForwarderSOC")))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { "label-width": "0" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "short-item-input",
                          staticStyle: { width: "auto" }
                        },
                        [
                          _c("label", { staticStyle: { width: "135px" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("SeaExport.CommissionedNumberOfPackages")
                              )
                            )
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "short-input",
                              class: _vm.readonly ? "short-input-disabled" : ""
                            },
                            [
                              _c("auto-number-input", {
                                attrs: { no: "77", precision: 0, min: 0 },
                                on: { change: _vm.quantityContractChange },
                                model: {
                                  value: _vm.job.quantityContract,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "quantityContract", $$v)
                                  },
                                  expression: "job.quantityContract"
                                }
                              }),
                              _c("span")
                            ],
                            1
                          ),
                          _c("label", [
                            _vm._v(_vm._s(_vm.$t("SeaExport.ActualQuantity")))
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "short-input",
                              class: _vm.readonly ? "short-input-disabled" : ""
                            },
                            [
                              _c("auto-number-input", {
                                attrs: { no: "78", precision: 0, min: 0 },
                                on: { change: _vm.quantityActualChange },
                                model: {
                                  value: _vm.job.quantityActual,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "quantityActual", $$v)
                                  },
                                  expression: "job.quantityActual"
                                }
                              }),
                              _c("span")
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { "label-width": "0" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "short-item-input",
                          staticStyle: { width: "auto" }
                        },
                        [
                          _c("label", { staticStyle: { width: "135px" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("SeaExport.CommissionedGrossWeight")
                              )
                            )
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "short-input",
                              class: _vm.readonly ? "short-input-disabled" : ""
                            },
                            [
                              _c("auto-number-input", {
                                attrs: { no: "79", precision: 3, min: 0 },
                                on: { change: _vm.weightContractChange },
                                model: {
                                  value: _vm.job.weightContract,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "weightContract", $$v)
                                  },
                                  expression: "job.weightContract"
                                }
                              }),
                              _c("span", [_vm._v("KGS")])
                            ],
                            1
                          ),
                          _c("label", [
                            _vm._v(_vm._s(_vm.$t("SeaExport.ActualWeight")))
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "short-input",
                              class: _vm.readonly ? "short-input-disabled" : ""
                            },
                            [
                              _c("auto-number-input", {
                                attrs: { no: "80", precision: 3, min: 0 },
                                on: { change: _vm.weightActualChange },
                                model: {
                                  value: _vm.job.weightActual,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "weightActual", $$v)
                                  },
                                  expression: "job.weightActual"
                                }
                              }),
                              _c("span", [_vm._v("KGS")])
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { "label-width": "0" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "short-item-input",
                          staticStyle: { width: "auto" }
                        },
                        [
                          _c("label", { staticStyle: { width: "135px" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.CommissionedVolume"))
                            )
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "short-input",
                              class: _vm.readonly ? "short-input-disabled" : ""
                            },
                            [
                              _c("auto-number-input", {
                                attrs: { no: "81", precision: 3, min: 0 },
                                on: { change: _vm.cubageContractChange },
                                model: {
                                  value: _vm.job.cubageContract,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "cubageContract", $$v)
                                  },
                                  expression: "job.cubageContract"
                                }
                              }),
                              _c("span", [_vm._v("M³")])
                            ],
                            1
                          ),
                          _c("label", [
                            _vm._v(_vm._s(_vm.$t("SeaExport.ActualVolume")))
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "short-input",
                              class: _vm.readonly ? "short-input-disabled" : ""
                            },
                            [
                              _c("auto-number-input", {
                                attrs: { no: "82", precision: 3, min: 0 },
                                on: { change: _vm.cubageActualChange },
                                model: {
                                  value: _vm.job.cubageActual,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "cubageActual", $$v)
                                  },
                                  expression: "job.cubageActual"
                                }
                              }),
                              _c("span", [_vm._v("M³")])
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.$t("SeaExport.Package") }
                    },
                    [
                      _c("cargo-packing-select", {
                        staticStyle: { width: "260px" },
                        attrs: {
                          no: "83",
                          disabled: _vm.readonly,
                          "default-value": _vm.job.packing,
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.job.packing = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { "label-width": "0" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "short-item-input",
                          staticStyle: { width: "auto" }
                        },
                        [
                          _c(
                            "label",
                            { style: { width: _vm.isZh ? "135px" : "95px" } },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Pieces")))]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "short-input",
                              class: _vm.readonly ? "short-input-disabled" : ""
                            },
                            [
                              _c("auto-number-input", {
                                attrs: { no: "84", precision: 0, min: 0 },
                                model: {
                                  value: _vm.job.insideQuantity,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "insideQuantity", $$v)
                                  },
                                  expression: "job.insideQuantity"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "label",
                            { style: { width: _vm.isZh ? "65px" : "105px" } },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.ChargedWeight")))]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "short-input",
                              class: _vm.readonly ? "short-input-disabled" : ""
                            },
                            [
                              _c("el-input-number", {
                                attrs: {
                                  no: "85",
                                  controls: false,
                                  precision: 3
                                },
                                model: {
                                  value: _vm.job.chargeWeight,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "chargeWeight", $$v)
                                  },
                                  expression: "job.chargeWeight"
                                }
                              }),
                              _c("span", [_vm._v("M/T")])
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.PiecesType") } },
                    [
                      _c("cargo-packing-select", {
                        staticStyle: { width: "260px" },
                        attrs: {
                          no: "86",
                          disabled: _vm.readonly,
                          "default-value": _vm.job.insidePacking,
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.job.insidePacking = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Size") } },
                    [
                      _c("el-input", {
                        attrs: { no: "87", type: "textarea", rows: 3 },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.Size"),
                              _vm.job.measurements,
                              function(val) {
                                _vm.job.measurements = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.measurements,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "measurements", $$v)
                          },
                          expression: "job.measurements"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.job.salePrice,
                          expression: "job.salePrice"
                        }
                      ],
                      attrs: {
                        label: _vm.$t("SeaExport.SpecialPriceInstructions")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "88", type: "textarea", rows: 3 },
                        model: {
                          value: _vm.job.salePriceRemarks,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "salePriceRemarks", $$v)
                          },
                          expression: "job.salePriceRemarks"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.MBLTransportationClause")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "89",
                          "select-type": _vm.TYPE_NAMES.basic_data_ShippingTerm,
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.job.freightTerm
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.freightTerm = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.HBLTransportationClause")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "90",
                          "select-type": _vm.TYPE_NAMES.basic_data_ShippingTerm,
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.job.freightTermHBL
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.freightTermHBL = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("queryJob.IncoTerm") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "91",
                          "select-type": _vm.TYPE_NAMES.basic_data_IncoTerm,
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.job.incoTerm
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.incoTerm = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.ContractRateProperty") }
                    },
                    [
                      _c("cargo-require-select", {
                        attrs: {
                          no: "92",
                          options: _vm.bookingTerms,
                          "label-field": _vm.isZh
                            ? "chineseName"
                            : "englishName",
                          "value-field": "code",
                          clearable: false,
                          size: "mini"
                        },
                        model: {
                          value: _vm.job.bookingTerm,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "bookingTerm", $$v)
                          },
                          expression: "job.bookingTerm"
                        }
                      })
                    ],
                    1
                  )
                ],
                2
              ),
              _c(
                "el-form",
                {
                  staticStyle: { "margin-right": "10px" },
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": "135px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.$t("SeaExport.NotifyParty") }
                    },
                    [
                      _c("cargo-company-select", {
                        class: _vm.isZh ? "shipper-input" : "shipper-input-en",
                        attrs: {
                          no: "93",
                          disabled: _vm.readonly,
                          "method-params": { notify: true, active: true },
                          "default-value": _vm.job.notifyId || "",
                          placeholder: " ",
                          "static-options": _vm.hasChooseOwnTransceiverPermission
                            ? _vm.privateNotifyList
                            : null
                        },
                        on: { change: _vm.notifyChange }
                      }),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { no: "94", type: "primary" },
                          on: {
                            click: function($event) {
                              _vm.billAddressDialog.visible = true
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                      )
                    ],
                    1
                  ),
                  _vm._l(7, function(i) {
                    return _c(
                      "el-form-item",
                      { key: i, staticClass: "auto-width" },
                      [
                        _c("cargo-input", {
                          ref: "notifyLine" + i,
                          refInFor: true,
                          attrs: {
                            no: "95",
                            "auto-uppercase":
                              _vm.notUppercaseShipperConsigneNotify
                          },
                          on: {
                            change: function() {
                              return _vm.wrapAddr(
                                _vm.job,
                                "notifyLine" + i,
                                i + 1 > 7 ? null : "notifyLine" + (i + 1),
                                200
                              )
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.NotifyParty"),
                                _vm.mergeNotifyLine(),
                                _vm.splitNotifyLine,
                                true
                              )
                            }
                          },
                          model: {
                            value: _vm.job["notifyLine" + i],
                            callback: function($$v) {
                              _vm.$set(_vm.job, "notifyLine" + i, $$v)
                            },
                            expression: "job['notifyLine'+i]"
                          }
                        })
                      ],
                      1
                    )
                  }),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.FreeDetension") } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: { no: "96", controls: false },
                        on: {
                          input: function(val) {
                            _vm.job.freeDetention = val
                          }
                        },
                        model: {
                          value: _vm.job.freeTime,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "freeTime", $$v)
                          },
                          expression: "job.freeTime"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.ChineseDescriptionOfGoods")
                      }
                    },
                    [
                      _c("cargo-rich-textarea", {
                        staticStyle: {
                          height: "65px",
                          "min-height": "65px",
                          flex: "1"
                        },
                        attrs: {
                          no: "97",
                          disabled: !_vm.isEdit,
                          "auto-uppercase": false,
                          "auto-half-word": false
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.ChineseDescriptionOfGoods"),
                              _vm.job.cargoChineseName,
                              function(val) {
                                _vm.job.cargoChineseName = val
                              },
                              true,
                              { autoUppercase: true }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.cargoChineseName,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "cargoChineseName", $$v)
                          },
                          expression: "job.cargoChineseName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.EnglishDescriptionOfGoods")
                      }
                    },
                    [
                      _c("cargo-rich-textarea", {
                        staticStyle: {
                          height: "65px",
                          "min-height": "65px",
                          flex: "1"
                        },
                        attrs: {
                          no: "98",
                          "text-chars": 0,
                          "warning-count": -1,
                          disabled: !_vm.isEdit,
                          "auto-uppercase": _vm.isUppercaseByConfig
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.EnglishDescriptionOfGoods"),
                              _vm.job.cargoEnglishName,
                              function(val) {
                                _vm.job.cargoEnglishName = val
                              },
                              _vm.isUppercaseByConfig,
                              { autoUppercase: _vm.isUppercaseByConfig }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.cargoEnglishName,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "cargoEnglishName", $$v)
                          },
                          expression: "job.cargoEnglishName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.HsCode") } },
                    [
                      _c("el-input", {
                        attrs: { no: "99", type: "textarea", rows: 3 },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.HsCode"),
                              _vm.job.hsCode,
                              function(val) {
                                _vm.job.hsCode = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.hsCode,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "hsCode", $$v)
                          },
                          expression: "job.hsCode"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Marks") } },
                    [
                      _c("cargo-rich-textarea", {
                        staticStyle: {
                          height: "65px",
                          "min-height": "65px",
                          flex: "1"
                        },
                        attrs: {
                          no: "100",
                          "text-chars": 0,
                          "warning-count": -1,
                          disabled: !_vm.isEdit,
                          "auto-uppercase": _vm.isUppercaseByConfig
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.Marks"),
                              _vm.job.mark,
                              function(val) {
                                _vm.job.mark = val
                              },
                              _vm.isUppercaseByConfig,
                              { autoUppercase: _vm.isUppercaseByConfig }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.mark,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "mark", $$v)
                          },
                          expression: "job.mark"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CategoryOfGoods") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "101",
                          "select-type":
                            _vm.TYPE_NAMES.basic_data_CargoInformation,
                          disabled: _vm.readonly,
                          filterable: "",
                          clearable: true,
                          "default-value": _vm.job.cargoCode,
                          "allow-create": false
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.cargoCodeChange(p.value)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: {
                          no: "102",
                          disabled: !(
                            _vm.isEdit &&
                            _vm.job.cargoCode != "" &&
                            _vm.job.cargoCode != null
                          )
                        },
                        model: {
                          value: _vm.job.cargoName,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "cargoName", $$v)
                          },
                          expression: "job.cargoName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CustomsBroker") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "103",
                          disabled: !_vm.job.customs,
                          "select-type": _vm.TYPE_NAMES.basic_data_Company,
                          "data-filter-function": _vm.customsBrokerFilter,
                          filterable: "",
                          "default-value": _vm.job.customsBroker || "",
                          placeholder: _vm.$t(
                            "SeaExport.PleaseTickCustomsDeclarationOption"
                          ),
                          "method-params": {
                            customsBroker: true,
                            companyLob: "seaExport",
                            active: true
                          }
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.customsBrokerChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.CustomsDeclarationType")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "customsDeclarationType",
                          disabled: !_vm.job.customs,
                          "select-type":
                            _vm.TYPE_NAMES.basic_data_CustomsDeclarationType,
                          filterable: "",
                          "default-value":
                            _vm.job.customsDeclarationType === -1
                              ? ""
                              : _vm.job.customsDeclarationType,
                          placeholder: _vm.$t("CargoMsg.Cargo_keyWordsTip")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.customsDeclarationType = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  !_vm.isSalesForSzfs
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.HaulageCompany") }
                        },
                        [
                          _c("cargo-company-select", {
                            attrs: {
                              no: "104",
                              disabled: !_vm.job.landTransportation,
                              "method-params": { truckCmp: true, active: true },
                              "default-value": _vm.job.carryingCmp || "",
                              placeholder: _vm.$t(
                                "SeaExport.PleaseTickDoorLoadingDeliveryOption"
                              ),
                              "custom-style": "width:260px"
                            },
                            on: { change: _vm.carryingCmpChangeHandler }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.job.landTransportation,
                          expression: "job.landTransportation"
                        }
                      ],
                      attrs: { label: _vm.$t("SeaExport.Door") }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "105",
                            "value-key": "name",
                            clearable: "",
                            filterable: "",
                            "allow-create": true
                          },
                          on: { change: _vm.doorsChangeHandler },
                          model: {
                            value: _vm.truckingInfo.doorName,
                            callback: function($$v) {
                              _vm.$set(_vm.truckingInfo, "doorName", $$v)
                            },
                            expression: "truckingInfo.doorName"
                          }
                        },
                        _vm._l(_vm.doorList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: item.name }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.job.landTransportation,
                          expression: "job.landTransportation"
                        }
                      ],
                      attrs: { label: _vm.$t("Payment.contactPerson") }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-input", {
                            staticClass: "short-el-input",
                            attrs: {
                              no: "106",
                              placeholder: _vm.$t("Payment.contactPerson")
                            },
                            model: {
                              value: _vm.truckingInfo.doorMan,
                              callback: function($$v) {
                                _vm.$set(_vm.truckingInfo, "doorMan", $$v)
                              },
                              expression: "truckingInfo.doorMan"
                            }
                          }),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "60px",
                                padding: "0 10px",
                                "font-size": "12px",
                                "text-align": "right"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Tel")))]
                          ),
                          _c("el-input", {
                            staticClass: "short-el-input",
                            attrs: {
                              no: "107",
                              placeholder: _vm.$t("SeaExport.Tel")
                            },
                            model: {
                              value: _vm.truckingInfo.doorManTel,
                              callback: function($$v) {
                                _vm.$set(_vm.truckingInfo, "doorManTel", $$v)
                              },
                              expression: "truckingInfo.doorManTel"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.job.landTransportation,
                          expression: "job.landTransportation"
                        }
                      ],
                      attrs: { label: _vm.$t("SeaExport.DoorAddress") }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "108", type: "textarea", rows: 3 },
                        model: {
                          value: _vm.truckingInfo.doorAddr,
                          callback: function($$v) {
                            _vm.$set(_vm.truckingInfo, "doorAddr", $$v)
                          },
                          expression: "truckingInfo.doorAddr"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.job.landTransportation,
                          expression: "job.landTransportation"
                        }
                      ],
                      attrs: {
                        label: _vm.$t(
                          "SeaExport.CargosExpectedArrivalDatePacking"
                        )
                      }
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          no: "loadingDate",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.truckingInfo.loadingDate,
                          callback: function($$v) {
                            _vm.$set(_vm.truckingInfo, "loadingDate", $$v)
                          },
                          expression: "truckingInfo.loadingDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                2
              ),
              _c(
                "el-form",
                {
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": "100px",
                    "label-position": "left"
                  }
                },
                [
                  _vm.job.destinationPortService
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.PortOfDestinationServices")
                          }
                        },
                        [
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { display: "block" },
                              attrs: { no: "dischargingPortDoor" },
                              model: {
                                value: _vm.job.dischargingPortDoor,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "dischargingPortDoor", $$v)
                                },
                                expression: "job.dischargingPortDoor"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.DispatchVehiclesAtDestination"
                                  )
                                ) + " "
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { display: "block" },
                              attrs: { no: "destPortCustomsClearance" },
                              model: {
                                value: _vm.job.destPortCustomsClearance,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.job,
                                    "destPortCustomsClearance",
                                    $$v
                                  )
                                },
                                expression: "job.destPortCustomsClearance"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.PortOfDestinationCustomsClearance"
                                  )
                                ) + " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.$t("SeaExport.SecondNotifyParty") }
                    },
                    [
                      _c("cargo-rich-textarea", {
                        staticStyle: { width: "260px", height: "216px" },
                        attrs: {
                          no: "109",
                          disabled: _vm.readonly,
                          "text-chars": 0
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.SecondNotifyParty"),
                              _vm.job.alsoNotify,
                              function(val) {
                                _vm.job.alsoNotify = val
                              },
                              true,
                              { warningCount: 45, maxChar: 0 }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.alsoNotify,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "alsoNotify", $$v)
                          },
                          expression: "job.alsoNotify"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "auto-width" },
                    [
                      _c("special-requests-grid", {
                        ref: "selectedSpecialRequest",
                        attrs: {
                          "is-edit": _vm.isEdit,
                          "customer-id": _vm.job.customerId,
                          lob: _vm.job.lob,
                          job: _vm.job
                        },
                        model: {
                          value: _vm.job.satisfiedRequests,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "satisfiedRequests", $$v)
                          },
                          expression: "job.satisfiedRequests"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.$t("SeaExport.Remarks") }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "110", type: "textarea", rows: 4 },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.Remarks"),
                              _vm.job.remarks,
                              function(val) {
                                _vm.job.remarks = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.remarks,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "remarks", $$v)
                          },
                          expression: "job.remarks"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.$t("SeaExport.UserDefinedField1") }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "111", type: "textarea", rows: 4 },
                        model: {
                          value: _vm.job.userDefinedField1,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "userDefinedField1", $$v)
                          },
                          expression: "job.userDefinedField1"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.$t("SeaExport.UserDefinedField2") }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "112", type: "textarea", rows: 4 },
                        model: {
                          value: _vm.job.userDefinedField2,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "userDefinedField2", $$v)
                          },
                          expression: "job.userDefinedField2"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.$t("SeaExport.UserDefinedField3") }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "113", type: "textarea", rows: 4 },
                        model: {
                          value: _vm.job.userDefinedField3,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "userDefinedField3", $$v)
                          },
                          expression: "job.userDefinedField3"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.$t("SeaExport.UserDefinedField4") }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "114", type: "textarea", rows: 4 },
                        model: {
                          value: _vm.job.userDefinedField4,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "userDefinedField4", $$v)
                          },
                          expression: "job.userDefinedField4"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.TaxNature") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "taxNature",
                            placeholder: _vm.$t("SeaExport.PleaseSelect"),
                            size: "mini"
                          },
                          model: {
                            value: _vm.job.taxNature,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "taxNature", $$v)
                            },
                            expression: "job.taxNature"
                          }
                        },
                        _vm._l(_vm.TAX_NATURES, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c("bill-address-dialog", {
        attrs: {
          visible: _vm.billAddressDialog.visible,
          job: _vm.job,
          "own-permission": _vm.hasChooseOwnTransceiverPermission,
          "customer-cmp-list": _vm.customerCmpList,
          "use-empty-customer-cmp-list": true
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.billAddressDialog, "visible", $event)
          },
          callback: _vm.codeSearchCallback
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "320px" },
            attrs: {
              disabled: _vm.readonly,
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
              "auto-uppercase": _vm.advanceTextDialog.formatObj.autoUppercase
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { no: "115", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "116" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }